import React from "react";
import { useHistory } from "react-router-dom";
import { useStore } from "../../store/useStore";
import Layout from "../../components/Layout/Layout";
import Title from "antd/lib/typography/Title";
import { Row, Col, Button } from "antd";
import { destroySession } from "../../store/actions";
import { LogoutOutlined } from "@ant-design/icons";

const UnauthorizedPage: React.FC = () => {
  const { dispatch } = useStore();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await dispatch(destroySession());
      history.replace("/login");
    } catch (error) { }
  };

  return (
    <Layout>
      <Row>
        <Col xs={24} style={{textAlign:"center"}}>
          <Title level={4}>
            <span className="text-red-500 font-bold">401</span> - You are not
          authorized to view this page
        </Title>
        </Col>
        <Col xs={24} style={{textAlign:"center"}}>
          <Button
            type="link"
            size="large"
            onClick={() => {
              handleLogout();
            }}
          >Log out</Button>
        </Col>
      </Row>
    </Layout>
  );
};

export default UnauthorizedPage;
